import { render, staticRenderFns } from "./ChooseConsolidationTypePopup.vue?vue&type=template&id=0f3c6b65&scoped=true"
import script from "./ChooseConsolidationTypePopup.vue?vue&type=script&lang=js"
export * from "./ChooseConsolidationTypePopup.vue?vue&type=script&lang=js"
import style0 from "./ChooseConsolidationTypePopup.vue?vue&type=style&index=0&id=0f3c6b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c6b65",
  null
  
)

export default component.exports